import Vue from 'vue'
import Element from 'element-ui'
import scroll from 'vue-seamless-scroll'
import Icon from '@/components/Icon.vue'
import '@/theme/element-#41B883/index.css'
import '@/assets/styl/index.styl'
import utils from '@/utils/base.js'
import limit from '@/utils/limit.js'
import Plugins from './utils/plugin.js'
import permission from './utils/permission.js'
import 'babel-polyfill'
// import '@/mock'
import promise from 'es6-promise'

import App from '@/App'
import { router } from '@/router'
import '@/router/routerControl'
import store from '@/store'
// import ECharts from 'vue-echarts/components/ECharts.vue'
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/tooltip'
// Vue.component('chart', ECharts)
import exportDate from '@/components/exportDate'
import rightBox from '@/components/noHaveData/rightBox'
import mapBox from '@/components/noHaveData/map'
import i18n from '@/lang'

Vue.component('icon', Icon)
Vue.component('exportDate', exportDate) // 导出公共组件
Vue.component('rightBox', rightBox) // 地图左侧无数据样式
Vue.component('mapBox', mapBox) // 地图无数据
promise.polyfill()
Vue.use(scroll)
Vue.use(Element, {
  size: 'medium',
  i18n: (key, value) => i18n.t(key, value)
})
Vue.use(utils)
Vue.use(limit)
Vue.use(Plugins)
Vue.use(permission)
Vue.config.productionTip = false
window.vm = new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: {
    App
  },
  template: '<App/>'
})
